import React, { createContext } from 'react'

export const FileManagementContext = createContext();

export const FileManagementProvider = ({ fileManagmentOpts, children }) => {
  return <FileManagementContext.Provider value={{ fileManagement_state: { fileManagmentOpts } }} >
    {children}
  </FileManagementContext.Provider >
}
